(function() {
    'use strict';

    angular
        .module('ccsTrApp')
        .factory('ShipmentGridDTO', ShipmentGridDTO);

    ShipmentGridDTO.$inject = ['$resource','DateUtils'];

    function ShipmentGridDTO($resource, DateUtils) {
        var resourceUrl = "api/shipmentGridDTO/:id";

        return $resource(resourceUrl, {}, {
            'query': {method:'GET',isArray: true},
            'get': {
                method: 'GET',
                transformResponse:function(data) {
                    if(data) {
                        data = angular.fromJson(data);
                        data.modifiedOn = DateUtils.convertDateTimeFromServer(data.modifiedOn);
                        data.siDate = DateUtils.convertLocalDateFromServer(data.siDate);
                    }
                    return data;
                }
            }
        });
    }
})();
